export enum PatientPhysicianStatusEnum {
  PendingVerification = 1,
  Verified = 2,
  RefusedByPrimary = 3
}

export const PatientPhysicianStatusOptions = [
{ id: 1, label: 'Pending Verification' },
{ id: 2, label: 'Verified' },
{ id: 3, label: 'Refused By Primary' }
];
